import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { read } from "Helpers/LocalStorage";
import { getNotificationCount } from "Stores/actions";
import StatusHandler from "Helpers/StatusHandler";
import { DialogActions } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import * as Icons from "react-bootstrap-icons";
import NotificationsService from "Services/http/endpoints/notifications/NotificationsService";
import { GETAGAINNOTIFICATION } from "Stores/actionTypes";
import fileDownload from "js-file-download";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { useTranslation } from "react-i18next";
import getFileTypeIcon from "Helpers/fileTypeIcon";

function ManageNotification({ row }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [showDialog, setShowDialog] = useState(false);
  const [Loading, setLoading] = useState(false);
  const { direction } = useTheme();

  const onShowDialog = () => {
    setShowDialog(true);
  };

  const onCloseDialog = async () => {
    if (!row.IsRead) await setAsRead();
    setShowDialog(false);
  };

  const getFileDownload = async () => {
    if (row.File) {
      setLoading(true);
      const response = await NotificationsService.getNotificationsFile({
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        NoticeUserId: row.Id,
        Id: row.File.Id,
        Type: row.File.Type,
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        fileDownload(blob, row.File.FileName);
      }
      setLoading(false);
    }
  };

  const setAsRead = async () => {
    try {
      setLoading(true);
      const response = await NotificationsService.putIsRead({
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
        IsRead: true,
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        await dispatch(getNotificationCount());
        dispatch({
          type: GETAGAINNOTIFICATION,
          status: true,
        });
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="viewDetails" />}
        icon={<Icons.CardList size={20} />}
        className="warning-fill"
        onClick={onShowDialog}
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={onCloseDialog}
        fullWidth
        maxWidth="sm"
      >
        <div className="dialogHeader">
          <p>
            <span>{row.Title}</span>
          </p>
          <span
            className={`alert alert-${
              row.IsRead ? "success" : "danger"
            } p-0 px-2 m-0 mt-1 mt-sm-0`}
          >
            {row.IsRead ? t("read") : t("unread")}
          </span>
        </div>
        <DialogContent>
          <BackDropLoading loading={Loading} />
          <Grid container spacing={2}>
            <Grid item xs={12} className="d-flex flex-row g-2">
              <span>{`${t("messageDate")} :`}</span>
              <p className="normalTitle">{row.DateRegister}</p>
            </Grid>
            <Grid item xs={12} className="d-flex flex-row g-2">
              <span>{`${t("group")} :`}</span>
              <p className="normalTitle">{row.GroupNotice}</p>
            </Grid>
            {row.Descript && (
              <Grid item xs={12} className="d-flex flex-column g-2">
                <span>{`${t("describe")} :`}</span>
                <p style={{ lineHeight: "1.7rem" }}>{row.Descript}</p>
              </Grid>
            )}
            {row.File && (
              <Grid
                item
                xs={12}
                className="d-flex flex-column g-2 border-top pt-2 mt-2"
              >
                <span>{`${t("fileAttachment")} :`}</span>
                <Grid className="file-attachment">
                  <p>{row.File.FileName}</p>
                  <MuiButton
                    className="link"
                    title={t('viewFile')}
                    innerIcon={getFileTypeIcon(row.File.FileName)}
                    disabled={row.File ? false : true}
                    onClick={getFileDownload}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <MuiButton
            onClick={onCloseDialog}
            title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ManageNotification;
